export default __webpack_public_path__ + "static/webshop-feb50369ef317867caf8deb4eae1d6a0.png";